<template>
  <div id="app">
    <v-app id="inspire">
      <v-card v-model="show" color="#FFFF99">
        <v-card-title>
          <v-icon large left>mdi-excavator</v-icon>
          Listado de Obras
        </v-card-title>
        <v-card-text class="pt-2">
          <v-row dense>
            <v-col cols="8" sm="8" md="8">
              <v-text-field dense v-model="filtroobra" label="Filtrar por Obra">
              </v-text-field>
            </v-col>
            <v-col cols="2" sm="2" md="1">
              <v-icon large left @click="cargarObras(obrasactivas, filtroobra)"
                >mdi-magnify</v-icon
              >
            </v-col>
            <v-col cols="12" sm="2" md="3">
              <v-switch
                dense
                v-model="obrasactivas"
                :label="'Sólo Obras activas'"
                @change="cargarObras(obrasactivas, filtroobra)"
              ></v-switch>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
      <v-card>
        <v-data-table
          dense
          :headers="headers"
          :items="listadoObras"
          locale="es-ar"
          class="elevation-1"
          :items-per-page="20"
          :footer-props="{
            itemsPerPageText: 'Obras por página',
          }"
        >
          <!-- <template v-slot:top>
      <v-toolbar
        flat
      >
        <v-toolbar-title>Listado de Obras</v-toolbar-title>
        <v-divider
          class="mx-4"
          inset
          vertical
        ></v-divider>
        <v-spacer></v-spacer>
        </v-toolbar>
    </template>
     -->
        </v-data-table>
      </v-card>
    </v-app>
  </div>
</template>
<style scoped>
::v-deep .v-data-table__empty-wrapper {
  display: none;
}
</style>

<script>
import axios from "../../../src/axios-auth";
export default {
  data: (vm) => ({
    editedItem: {},
    editedIndex: -1,
    filtroobra: "",
    obras: [],
    listadoObras: [],
    obrasactivas: false,
    headers: [
      {
        text: "Código",
        align: "start",
        sortable: false,
        value: "codigo",
      },
      { text: "Obra", value: "nombre" },
      { text: "Cliente", value: "cliente" },
    ],
  }),

  computed: {
    show: {
      get() {
        this.cargarObras(false);
        this.$store.state.sector = "Obra";
        return this.visible;
      },
      set(value) {
        if (!value) {
          this.$refs.form.resetValidation();
          //this.vaciarModels();
          this.$emit("close");
        }
      },
    },
  },
  methods: {
    scrollToTop() {
      window.scrollTo(0, 0);
    },

    cargarObras(valor, filtro) {
      let self = this;
      if (valor == true) {
        axios
          .get("/Obras/GetObrasPA", {
            params: {
              estado: "P",
              filtro: filtro,
            },
          })
          .then((response) => {
            self.listadoObras = response.data;
          })
          .catch((error) => {
            self.listadoObras = [];
          });
      } else {
        axios
          .get("/Obras/GetObrasPA", {
            params: {
              estado: "",
              filtro: filtro,
            },
          })
          .then((response) => {
            self.listadoObras = response.data;
          })
          .catch((error) => {
            self.listadoobras = [];
          });
      }
    },

    showAlert(alertInfo) {
      alertInfo.vm.$swal.fire({
        icon: alertInfo.icon,
        title: alertInfo.title,
        showConfirmButton: false,
        background: "#ececec",
        timer: 1500,
      });
    },
  },
};
</script>
